// removed by extract-text-webpack-plugin
module.exports = {"headline":"_176rG","alert":"_18_Xf","icon":"_1i7Ya","text":"_3WBpM","list":"_1tqYt","item":"_2VUEd","inner":"_1skwA","link":"_37TBY"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ConvenienceStoreInstruction/ConvenienceStoreInstruction.scss
// module id = 1623
// module chunks = 1